if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.includesExcludes
) {
  Object.defineProperty(Array.prototype, 'includesExcludes', {
    value(arr1, ...arr2) {
      if (!Array.isArray(arr1)) arr1 = [arr1];
      for (const a of arr1.flat()) {
        if (!this.includes(a)) return false;
      }
      for (const b of arr2.flat()) {
        if (this.includes(b)) return false;
      }
      return true;
    }
  });
}